<template>
	<div class="fancafe_recommend" id="fancafe_recommend" v-if="recommendList.length > 0">
		<div class="inner_recommend" id="recommend">
			<div class="group_panel">
				<div class="recommend_title cafe">
					<span class="txt_state">{{ recommendSet.label }}</span>
					<strong class="tit_recommend">{{ recommendSet.subject1 }}<em>{{ recommendSet.subject2 }}</em></strong>
				</div>
				<div class="wrap_btn">
					<button class="btn_g btn_prev"
							:class="{btn_disabled: !hasPrev}"
							@click="prev"
							id="recommendPrev"><span class="ico_cafetop">이전 보기</span></button>
					<button class="btn_g btn_next"
							:class="{btn_disabled: !hasNext}"
							@click="next"
							id="recommendNext"><span class="ico_cafetop">다음 보기</span></button>
				</div>
			</div>
			<div class="wrap_list">
				<ul class="track_list" id="recommendList">
					<recommend-item v-for="(recommend, index) in recommendList" v-bind="recommend" :key="'recommend-' + index"></recommend-item>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import RecommendItem from "./RecommendItem.vue";
import $ from "jquery";

export default {
	components: {
		RecommendItem
	},
	data() {
		return {
			recommendSets: [],

			recommendSetPage: 0,
			recommendListPage: 0,

			readyToMove: true,
			moveSize: -885,
			duration: 500
		}
	},
	computed: {
		recommendSetMaxPage() {
			return Math.max(this.recommendSets.length - 1, 0);
		},
		recommendListMaxPage() {
			const ret = Math.ceil(this.recommendList.length / 3);
			return Math.max(ret - 1, 0);
		},
		recommendSet() {
			return this.recommendSets[this.recommendSetPage]?.recommendSet ?? {};
		},
		recommendList() {
			return this.recommendSet.recommendList || [];
		},
		hasPrev() {
			return this.recommendSetPage > 0 || this.recommendListPage > 0;
		},
		hasNext() {
			return this.recommendSetPage < this.recommendSetMaxPage || this.recommendListPage < this.recommendListMaxPage;
		}
	},
	methods: {
		getRecommend() {
			const url = '/_c21_/api/fancafe/recommendSets';
			$.ajax({url}).then((res) => {
				res.sort(() => Math.random() - 0.5);
				this.recommendSets = res;
			});
		},
		prev() {
			if (!this.hasPrev || !this.readyToMove) {
				return;
			}

			if (this.recommendListPage === 0) {
				this.recommendSetPage--;
				this.recommendListPage = this.recommendListMaxPage;
				$("#recommendList").css({"left": this.recommendListPage * this.moveSize});
				return;
			}

			this.readyToMove = false;
			this.recommendListPage--;
			const p = this.recommendListPage * this.moveSize;
			$("#recommendList").animate({"left": p}, this.duration, () => {
				this.readyToMove = true;
			});
		},
		next() {
			if (!this.hasNext || !this.readyToMove) {
				return;
			}
			if (this.recommendListPage === this.recommendListMaxPage) {
				this.recommendSetPage++;
				this.recommendListPage = 0;
				$("#recommendList").css({"left": this.recommendListPage});
				return;
			}

			this.readyToMove = false;
			this.recommendListPage++;
			const p = this.recommendListPage * this.moveSize;
			$("#recommendList").animate({"left": p}, this.duration, () => {
				this.readyToMove = true;
			});
		}
	},
	created() {
		this.getRecommend();
	}
}
</script>
